export let resend = "ZCFlPd";
export default {resend};